<template>
  <div class="progress">
    <div class="banner"></div>
    <div class="profile">
      <div class="profile-header">
        <div class="title">
          <div class="cont_tit">
            <p>
              {{
                id == 1
                  ? "集团动态"
                  : id == 2
                  ? "招聘公告"
                  : id == 3
                  ? "考试通知"
                  : id == 4
                  ? "党建文化"
                  : id == 5
                  ? "引才政策"
                  : id == 7
                  ? "干训政策"
                  : id == 8
                  ? "培训项目"
                  : ""
              }}
            </p>
            <span>{{
              id == 1
                ? "Group Dynamics"
                : id == 2
                ? "Recruitment Announcement"
                : id == 3
                ? "Examination Notice"
                : id == 4
                ? "Party Building Culture"
                : id == 5
                ? "Talent Recruitment Policy"
                : id == 7
                ? "Training Policy"
                : id == 8
                ? "Training Program"
                : ""
            }}</span>
          </div>
          <div class="crumb">
            <span>当前位置：</span>
            <a href="../" target="_self" title="首页" class="CurrChnlCls"
              >首页</a
            >&gt;<router-link
              :to="
                id < 7
                  ? { path: '/announcement', query: { announcementId: '1' } }
                  : { path: '/servicehall', query: { servicehallId: '5' } }
              "
              class="CurrChnlCls"
              >{{ id < 7 ? "新闻中心" : "人才培训" }}</router-link
            >&gt;<router-link
              :to="
                id < 7
                  ? {
                      path: '/announcement',
                      query: { announcementId: id },
                    }
                  : {
                      path: '/servicehall',
                      query: { servicehallId: '5', id: id - 4 },
                    }
              "
              class="CurrChnlCls"
              >{{
                id == 1
                  ? "集团动态"
                  : id == 2
                  ? "招聘公告"
                  : id == 3
                  ? "考试通知"
                  : id == 4
                  ? "党建文化"
                  : id == 5
                  ? "引才政策"
                  : id == 7
                  ? "干训政策"
                  : id == 8
                  ? "培训项目"
                  : ""
              }}</router-link
            >
          </div>
        </div>
      </div>
      <div class="resumeForm">
        <div class="content-header">
          <h2>{{ data.commentTitle }}</h2>
          <div class="content-header-time" v-if="data.releaseTime">
            发布时间：{{ data.releaseTime.split(" ")[0] }}
          </div>
        </div>
        <div class="content-con">
          <div ref="htmlContainer" class="ql-editor"></div>
          <!-- <pre class="ql-editor" v-html="data.text"></pre> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCommentById,getPreviewUrl, download  } from "@/api/index";
import { encryptSm4, decryptSm4 } from "@/helper/sm4";
export default {
  name: "announcement",
  data() {
    return {
      id: "",
      data: {},
      originalHtml: "",
      processedHtml: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    let cmCommentId = this.$route.params.cmCommentId;
    this.getList(cmCommentId);
  },
  methods: {
    getList(cmCommentId) {
      const loading = this.$loading();
      getCommentById(cmCommentId)
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.code == 200) {
            this.data = res.data;
            this.originalHtml = res.data.text;
            this.$nextTick(() => {
              this.processHtmlContent();
            });
          }
        })
        .catch(() => {
          loading.close();
        });
    },

    // 核心处理逻辑：解析 HTML → 提取关键内容 → 调用接口 → 替换链接 → 输出完整 HTML
    async processHtmlContent() {
      const container = this.$refs.htmlContainer;
      // 手动注入原始 HTML 到容器
      container.innerHTML = this.originalHtml;

      // 等待 DOM 渲染完成（确保 video、img 标签已存在）
      await this.$nextTick();

      try {
        // 1. 处理视频：提取 poster → 调用接口 → 替换 source 的 src
        await this.handleVideoElements(container);
        // 2. 处理图片：提取 alt → 调用接口 → 替换 img 的 src
        await this.handleImageElements(container);
        // 3. 处理附件：绑定点击事件 → 提取 download 属性 → 调用下载接口
        this.bindAttachmentDownload(container);
        // 4. 获取处理后的完整 HTML（保留所有原始标签和样式）
        this.processedHtml = container.innerHTML;
      } catch (error) {
        console.error("HTML 处理失败", error);
        this.processedHtml = this.originalHtml; // 失败时返回原始 HTML
      }
    },

    // 处理视频标签：poster → 接口 → 替换 source src
    async handleVideoElements(container) {
      const videoElements = container.querySelectorAll("video");
      if (videoElements.length === 0) return;

      for (const video of videoElements) {
        const posterValue = video.getAttribute("poster"); // 提取 poster 内容作为 objectKey
        const sourceElement = video.querySelector("source"); // 获取 video 内的 source 标签
        if (!posterValue || !sourceElement) continue;

        try {
          // 调用接口获取新视频链接
          const response = await this.getPreviewUrl(posterValue);
          if (response?.msg) {
            sourceElement.setAttribute("src", decryptSm4(response.msg)); // 替换 source 的 src
          }
        } catch (error) {
          console.error(`处理视频 poster: ${posterValue} 失败`, error);
        }
      }
    },

    // 处理图片标签：alt → 接口 → 替换 img src
    async handleImageElements(container) {
      const imgElements = container.querySelectorAll("img");
      if (imgElements.length === 0) return;

      for (const img of imgElements) {
        const altValue = img.getAttribute("alt"); // 提取 alt 内容作为 objectKey
        if (!altValue) continue;

        try {
          // 调用接口获取新图片链接
          const response = await this.getPreviewUrl(altValue);
          if (response?.msg) {
            img.setAttribute("src", decryptSm4(response.msg)); // 替换 img 的 src
          }
        } catch (error) {
          console.error(`处理图片 alt: ${altValue} 失败`, error);
        }
      }
    },

    // 绑定附件下载事件：点击 a 标签触发下载
    bindAttachmentDownload(container) {
      const attachmentLinks = container.querySelectorAll("a[download]");
      if (attachmentLinks.length === 0) return;

      attachmentLinks.forEach((link) => {
        // 关键修复1：保留有效 href，确保浏览器识别为可点击元素
        link.setAttribute("href", "javascript:;"); // 占位，不跳转
        link.style.cursor = "pointer";
        link.style.color = "#409EFF"; // 视觉提示可点击
        link.style.textDecoration = "underline";

        // 关键修复2：移除可能存在的旧事件，避免冲突
        link.onclick = null;

        // 关键修复3：用 onclick 绑定（比 addEventListener 更稳定，避免 DOM 渲染覆盖）
        link.onclick = async (e) => {
          e.preventDefault(); // 阻止默认行为（避免 javascript:; 触发空跳转）
          e.stopPropagation(); // 阻止事件冒泡被其他组件拦截

          const downloadValue = link.getAttribute("download");

          if (!downloadValue) return;

          try {
            const fileName = downloadValue.split("/").pop();
            const fileType = fileName.split(".").pop() || "pdf";
            const templateName = fileName.replace(`.${fileType}`, "");

            // 调用下载接口
            const response = await this.download("湖北省人才网/新闻/附件/" + downloadValue);

            this.getObjectURL(response, `${templateName}.${fileType}`);
          } catch (error) {
            console.error(
              `附件下载失败（download值：${downloadValue}）`,
              error
            );
            this.$message.error("附件下载失败，请重试");
          }
        };
      });
    },

    // 封装接口调用（保持原始 then 语法结构）
    getPreviewUrl(objectKey) {
      return new Promise((resolve, reject) => {
        // 实际使用时替换为真实接口，此处保留原逻辑
        getPreviewUrl(encryptSm4(objectKey))
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // 封装附件下载接口调用
    download(resume) {
      return new Promise((resolve, reject) => {
        download(encryptSm4(resume))
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // 将返回的文件流数据转换为url（data: 文件流数据）
    getObjectURL(data, contractFileName) {
      let blob = new Blob([data]);
      let fileName = contractFileName;
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        //释放内存
        window.URL.revokeObjectURL(link.href);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/cyzcpc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}
.profile {
  width: 70%;
  margin: auto;
  &-header {
    padding-top: 50px;
    margin-bottom: 50px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }

    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }
  .resumeForm {
    margin: 30px 0;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;
    .content-header {
      margin-bottom: 20px;
      .content-header-time {
        margin-top: 20px;
        font-size: 14px;
      }
    }
    .content-con {
      border-top: 1px solid #e5e5e5;
      .ql-editor {
        font-size: @font-size-base;
        color: @primary-text-color;
        line-height: 2em;
        overflow: hidden;
        box-sizing: border-box;
        white-space: pre-wrap;
        word-wrap: break-word;
        ::v-deep a {
          color: rgb(52, 152, 219) !important;
        }
        ::v-deep img {
          width: 100%;
        }
      }
    }
  }
}
</style>
